export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creación de widget para"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuenta"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pago en"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto del pago"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acciones al éxito"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acciones al fallo"])}
}